export default {
  TNC_ERROR: 'Para iniciar sesión, primero debe aceptar las Condiciones generales y la Política de privacidad de CampoImpulso.',
  WELCOME_BACK: '¡Bienvenidos de nuevo! Ha iniciado sesión correctamente.',
  TNC_LABEL: 'Al marcar esta casilla, aceptas los Términos y condiciones de Fielddrive.',
  TNC: 'Condiciones generales',
  TNC_LINK: 'https://www.fielddrive.com/terms-and-conditions',
  LOWER_AND: 'y',
  POLICY: 'Política de privacidad',
  POLICY_LINK: 'https://www.fielddrive.com/privacy-policy',
  POLICY_LABEL: 'Autoriza a clientes potenciales de CampoImpulso a procesar sus datos personales para los fines especificados allí.',
  LOGIN: 'Inicio de sesión'
}
